import { render, staticRenderFns } from "./StudentCardIdsReportFilter.vue?vue&type=template&id=c360b116&"
import script from "./StudentCardIdsReportFilter.vue?vue&type=script&lang=js&"
export * from "./StudentCardIdsReportFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports